import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { NotFoundContent } from '../NotFoundContent/NotFoundContent';

type Props = { title?: string; description?: string };

export const NotFoundArticles: FC<Props> = ({ title, description }) => {
    const { t } = useTranslations();

    return (
        <NotFoundContent
            title={title ?? t['blog.articles_not_found.title']}
            description={description ?? t['blog.articles_not_found.general']}
        />
    );
};
